import { useNavigate } from 'react-router-dom';
import useFreeConsultationCheck from '../../../../../../hooks/useFreeConsultationCheck';
import { openSimplePracticeBooking } from '../../../../../../utils/simplePractice';

export const usePractitionerActions = () => {
  const navigate = useNavigate();
  const {
    showDialog,
    cancelling,
    dismiss,
    cancelAndProceed,
  } = useFreeConsultationCheck();

  const handlePractitionerClick = (practitioner) => () => {
    navigate(`/practitioner-profile/${practitioner.name.replace(/\s+/g, '-').toLowerCase()}`, {
      state: { user: practitioner.userData },
    });
  };

  const handleBookConsultation = (practitioner) => () => {
    openSimplePracticeBooking(practitioner?.name);
  };

  return {
    handlePractitionerClick,
    handleBookConsultation,
    freeConsultationDialog: { showDialog, cancelling, dismiss, cancelAndProceed },
  };
};
